import React from "react";
import { VStack, HStack, Text, IconButton, Icon } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";
import useIcons from "../../hooks/useIcons";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  currentPageRecords: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
  loading?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalRecords,
  currentPageRecords,
  onPreviousPage,
  onNextPage,
  loading = false,
}) => {
  const colors = useThemeColors();
  const icons = useIcons();

  // Don't render if there's only one page
  if (totalPages <= 1) {
    return null;
  }

  return (
    <VStack
      gap={2}
      p={4}
      borderTop="1px solid"
      borderColor={colors.border.primary}
    >
      <HStack justify="center" gap={2}>
        <IconButton
          aria-label="Previous page"
          size="sm"
          onClick={onPreviousPage}
          disabled={currentPage === 1 || loading}
        >
          <Icon as={icons.utility.chevronLeft} />
        </IconButton>
        <Text fontSize="sm">
          Page {currentPage} of {totalPages}
        </Text>
        <IconButton
          aria-label="Next page"
          size="sm"
          onClick={onNextPage}
          disabled={currentPage === totalPages || loading}
        >
          <Icon as={icons.utility.chevronRight} />
        </IconButton>
      </HStack>
      <Text fontSize="xs" color="gray.500">
        Showing {currentPageRecords} of {totalRecords} total entries
      </Text>
    </VStack>
  );
};

export default Pagination;
